import { Button, Grid } from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import styles from './style';

const { publicRuntimeConfig } = getConfig();

const EirOrderSummaryFooter = ({
  incompleteCart,
  // isCurrentServiceComplete,
  // isPortingComplete,
  // cartData,
  // cartInfo,
  // isPorting,
}) => {
  const theme = useTheme();
  const router = useRouter();
  // const [validationCheck, setValidationCheck] = useState(false);

  // useEffect(() => {
  //   if (cartData.hasBroadband && !isCurrentServiceComplete) {
  //     setValidationCheck(false);
  //   } else if (cartData.hasBillPayPlans) {
  //     setValidationCheck(false);
  //   } else if (cartData.hasSIMOnly) {
  //     if (!cartInfo.isPortInDone) {
  //       setValidationCheck(true);
  //     }
  //   } else {
  //     setValidationCheck(false);
  //   }
  // }, []);

  return (
    <Grid container justifyContent='center'>
      <Grid item xs={12} md={12} sx={{ ...styles(theme).buttonContainer }}>
        <Button
          variant='buttonMedium'
          sx={incompleteCart ? styles(theme).disableCTA : styles(theme).enableCTA}
          onClick={() =>
            router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/checkout/customer-profile`)
          }
          aria-label='Confirm & Continue'
        >
          Confirm & Continue
        </Button>
      </Grid>
    </Grid>
  );
};
export default EirOrderSummaryFooter;
